import { Const } from "@/const";

import { DebugHelper } from "@/helper/debugHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { RequestHelper } from "@/helper/requestHelper";

import { CloudAccount } from "@/cloudAccount/cloudAccount";
import platform from './platform';

export class CloudHelper{
    public static leftAloneInterval;
    public static updateInterval;

    // 15分放置のカウント
    public static cloudSignOutTimer(cloudAccount : CloudAccount){
        clearInterval(this.leftAloneInterval);

        cloudAccount.signOutTimeCount = Const.LABELYASAN_CLOUD_SIGN_OUT_TIME;

        this.leftAloneInterval = setInterval(() => {
            if(!cloudAccount.isSignIn){ return; }
            cloudAccount.signOutTimeCount--;
            DebugHelper.trace(cloudAccount.signOutTimeCount);

            if(cloudAccount.signOutTimeCount <= 0){
                DebugHelper.trace("ログアウト処理");
                this.signOut(cloudAccount, 2);
            }
        }, 60000);
    }

    // 30分ごとにリフレッシュトークンを更新するカウント
    public static updateRefreshTokenTimer(cloudAccount : CloudAccount){
        clearInterval(this.updateInterval);

        cloudAccount.updateRefreshTokenTimCount = Const.LABELYASAN_CLOUD_UPDATE_REFRESH_TOKEN_TIME;

        this.updateInterval = setInterval(() => {
            if(!cloudAccount.isSignIn){ return; }
            cloudAccount.updateRefreshTokenTimCount--;
            DebugHelper.trace(cloudAccount.updateRefreshTokenTimCount);

            if(cloudAccount.updateRefreshTokenTimCount <= 0){
                DebugHelper.trace("リフレッシュトークン更新");
                this.checkRefreshToken(() => {
                    this.updateRefreshTokenTimer(cloudAccount);
                });
            }
        }, 60000);
    }

    // ログアウト処理
    public static signOut(cloudAccount : CloudAccount, signOutType: number){
        clearInterval(this.leftAloneInterval);

        this.checkAccessToken((res) => {
            DebugHelper.trace("チェック完了");
            DebugHelper.trace(res);
            var param = {
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                refreshToken : CookieHelper.getItem("refreshToken"),
                platformId : String(platform.id)
            };

            RequestHelper.post("sign_out", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace("sign_out");
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    DebugHelper.trace("エラー");
                }
                else{
                    cloudAccount.isSignIn = false;
                    cloudAccount.signOutType = signOutType;
                    CookieHelper.removeItem("authorizationToken");
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    // アクセストークンの有効無効チェック
    public static checkAccessToken(callback){
        var param = {
            authorizationToken : CookieHelper.getItem("authorizationToken"),
            accessToken : CookieHelper.getItem("accessToken"),
            platformId : String(platform.id)
        };

        RequestHelper.post("check_access_token", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace("checkAccessToken");
            DebugHelper.trace(res);
            DebugHelper.trace(Object.keys(res.message).length);
            if(Object.keys(res.message).length > 0){
                DebugHelper.trace(res.message);
                if(res.message.accessToken && res.message.accessToken == "ユーザが存在しません"){
                    callback("deletedAccount");
                    return;
                }
                this.getAccessToken((res) => {
                    if(res){
                        DebugHelper.trace("再発行エラー");
                        DebugHelper.trace(res);
                        callback(res);
                    }
                    else{
                        DebugHelper.trace("トークン再発行");
                        callback();
                    }
                });
            }
            else{
                callback();
            }
        }, () => {
            DebugHelper.trace("エラー");
            callback("エラー");
        });
    }

    // 新しいアクセストークンの取得
    public static getAccessToken(callback){
        var param = {
            authorizationToken : CookieHelper.getItem("authorizationToken"),
            accessToken : CookieHelper.getItem("accessToken"),
            refreshToken : CookieHelper.getItem("refreshToken"),
            platformId : String(platform.id)
        };

        RequestHelper.post("get_access_token", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace("getAccessToken");
            DebugHelper.trace(res);
            if(Object.keys(res.message).length > 0){
                if(res.message.authorizationToken){
                    callback("timeout");
                }
                else{
                    DebugHelper.trace(res.message);
                    callback(res.message);
                }
            }
            else{
                CookieHelper.setItem("accessToken", res.data.accessToken);
                CookieHelper.setItem("refreshToken", res.data.refreshToken);
                CookieHelper.setItem("accessLimit", res.data.accessLimit);
                CookieHelper.setItem("refreshLimit", res.data.refreshLimit);
                callback();
            }
        }, () => {
            DebugHelper.trace("エラー");
            callback("エラー");
        });
    }

    // リフレッシュトークンの有効期限延長（現在日時より15分）
    public static checkRefreshToken(callback){
        var param = {
            authorizationToken : CookieHelper.getItem("authorizationToken"),
            accessToken : CookieHelper.getItem("accessToken"),
            refreshToken : CookieHelper.getItem("refreshToken"),
            platformId : String(platform.id)
        };

        RequestHelper.post("check_refresh_token", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(Object.keys(res.message).length > 0){
                DebugHelper.trace(res.message);
                callback(res.message);
            }
            else{
                // res.dataは空配列
                // リフレッシュトークン更新時にアクセストークンも更新する
                this.getAccessToken((getAccessTokenRes) => {
                    callback(getAccessTokenRes);
                })
            }
        }, () => {
            DebugHelper.trace("エラー");
            callback("エラー");
        });
    }
}
